import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.3.1_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@22.19.17_babel-plug_61c4c874a88bcd419d987be11d012b4f/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["StatsigExperimentContextProvider"] */ "/app/packages/statsig/src/StatsigExperimentContext.tsx");
